import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";

const UpdateTyreDetails = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setRowAddData,
  rowAddData,
  setSelectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [Staff, setStaff] = useState([]);
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFileds() {
    setRowAddData({
      received_date: "",
      new_tyre_num: "",
      old_tyre_num: "",
      new_purchase_date: "",
      start_km: "",
      current_km: "",
      running_km: "",
      tyre_brand: "",
      quality_status: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
    setSelectedRowsData("");
  }

  const handleUpdateData = async (e) => {
    e.preventDefault();
    const {
      id,
      received_date,
      new_tyre_num,
      old_tyre_num,
      new_purchase_date,
      start_km,
      current_km,
      running_km,
      tyre_brand,
      quality_status,
    } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/tyre/tyre-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        driver_id: selectedStafflId,
        new_tyre_num,
        old_tyre_num,
        start_km,
        current_km,
        running_km,
        tyre_brand,
        quality_status,
        received_date: moment(received_date).format("YYYY-MM-DD"),
        new_purchase_date: moment(new_purchase_date).format("YYYY-MM-DD"),
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    if (selectedRowsData) {
      getCompany();
    }
  }, [selectedRowsData]);

  useEffect(() => {
    if (selectedRowsData) {
      setSelectedCompanyId(selectedRowsData?.company_id);
      setSelectedStaffId(selectedRowsData?.driver_id);
      setSelectedVehicleId(selectedRowsData?.vehicle_id);
    }
  }, [selectedRowsData]);

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setSelectedCompanyId(value ? value : "");
    setStaff("");
  };

  const getStaff = async (e) => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStaff(result.data);
    } else {
      setStaff([]);
    }
  };
  useEffect(() => {
    if (selectedCompanyId) {
      getStaff();
    }
  }, [selectedCompanyId]);

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    if (selectedRowsData) {
    }
    getVehicle();
  }, [selectedRowsData]);
  return (
    <div
      className="modal custom-modal fade"
      id="editModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Update Tyre Details
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFileds}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Party Name</h4> */}
                  <form className="form-sample" onSubmit={handleUpdateData}>
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="company_name">Company Name</label>
                          <select
                            className="form-control form-control-lg"
                            onChange={handleCompanyChange}
                            value={selectedCompanyId}
                            id="company_name"
                            required
                          >
                            <option value="">Select Company Name</option>
                            {company &&
                              company?.length > 0 &&
                              company?.map((item, id) => {
                                return (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="staff_id">Driver Name</label>
                          <select
                            className="form-control form-control-lg"
                            onChange={handleStaffChange}
                            value={selectedStafflId}
                            id="staff_id"
                            required
                          >
                            <option value="">Select Driver Name</option>
                            {Staff &&
                              Staff?.length > 0 &&
                              Staff?.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <option
                                      value={item.id}
                                    >{`${item.staff_name}`}</option>
                                  </React.Fragment>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="material_name">Vehicle Number</label>
                          <select
                            className="form-control form-control-lg"
                            onChange={handleVehicleChange}
                            value={selectedVehicleId}
                            id="material_name"
                            required
                          >
                            <option value="">Select Vehicle</option>
                            {vehicle &&
                              vehicle?.length > 0 &&
                              vehicle?.map((item, id) => {
                                return (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.vehicle_number}`}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="received_date">Received Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="received_date"
                            id="received_date"
                            placeholder="Received Date"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.received_date}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="new_tyre_num">New Tyre Number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="new_tyre_num"
                            id="new_tyre_num"
                            placeholder="New Tyre Number"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.new_tyre_num}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="old_tyre_num">Old Tyre Number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="old_tyre_num"
                            id="old_tyre_num"
                            placeholder="Old Tyre Number"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.old_tyre_num}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="new_purchase_date">
                            New Purchase Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="new_purchase_date"
                            id="new_purchase_date"
                            placeholder="New Purchase Date"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.new_purchase_date}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="start_km">Start KM</label>
                          <input
                            type="text"
                            className="form-control"
                            name="start_km"
                            id="start_km"
                            placeholder="Start KM"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.start_km}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="current_km">Current KM</label>
                          <input
                            type="text"
                            className="form-control"
                            name="current_km"
                            id="current_km"
                            placeholder="Current KM"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.current_km}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="running_km">Running KM</label>
                          <input
                            type="text"
                            className="form-control"
                            name="running_km"
                            id="running_km"
                            placeholder="Running KM"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.running_km}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="tyre_brand">Tyre Brand</label>
                          <input
                            type="text"
                            className="form-control"
                            name="tyre_brand"
                            id="tyre_brand"
                            placeholder="Tyre Brand"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.tyre_brand}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="quality_status">Quality Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="quality_status"
                            id="quality_status"
                            placeholder="Quality Status"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.quality_status}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={handleAddDataSubmit}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateTyreDetails;
